export default __webpack_public_path__ + "static/media/bg-hi-tech2.b4b8d5d2.webp";